<template>
  <div
    class="frisbuy-popup-container"
    @click.self="() => onBlurHandler()"
    v-touch:swipe="(direction: TSwipe) => onSwipeHandler(direction)"
  >
    <div
      class="frisbuy-popup-container__content-wrapper"
      ref="contentWrapper"
      @scroll="(e) => scrollHandler(e)"
    >
      <slot name="closeButton">
        <button class="frisbuy-close-button" @click="$emit('close')">
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M25.6077 14.2944C25.2138 13.9073 24.5807 13.9127 24.1936 14.3066L19.9878 18.5857L15.7088 14.3801C15.3149 13.9929 14.6817 13.9984 14.2946 14.3923C13.9075 14.7862 13.913 15.4193 14.3068 15.8065L18.5859 20.0121L14.3801 24.2914C13.9929 24.6853 13.9984 25.3184 14.3923 25.7055C14.7862 26.0927 15.4193 26.0872 15.8065 25.6933L20.0123 21.4141L24.2916 25.62C24.6855 26.0071 25.3186 26.0016 25.7058 25.6077C26.0929 25.2138 26.0874 24.5807 25.6935 24.1936L21.4142 19.9877L25.6199 15.7086C26.0071 15.3147 26.0016 14.6815 25.6077 14.2944Z"
              fill="#999999"
            />
          </svg>
        </button>
      </slot>
      <slot name="content" v-bind="contentWrapperSlot"></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "@/widgets/MarketplaceReviews/mixins.scss";
.frisbuy-popup-container {
  &,
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    text-decoration: none;
    list-style: none;

    box-sizing: border-box;
  }

  display: flex;
  position: fixed;
  inset: 0;
  align-items: center;
  justify-content: center;

  width: 100dvw;
  height: 100dvh;
  padding: 40px;

  background-color: rgba($color: #000000, $alpha: 0.7);

  overflow: hidden;

  z-index: 100;

  .frisbuy-popup-container__content-wrapper {
    display: block;
    position: relative;
    width: min(920px, calc(100dvw - 80px));
    max-height: calc(100dvh - 80px);
    overflow: hidden;

    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.28);

    .frisbuy-close-button {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      width: 40px;
      height: 40px;
      border: none;
      border-radius: 0;
      background: transparent;
      outline: none;
      color: #999999;
      cursor: pointer;
      align-items: center;
      justify-content: center;
      z-index: 3;

      svg {
        display: block;
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  .frisbuy-popup-container {
    padding: 0;
    align-items: stretch;
    justify-content: stretch;

    .frisbuy-popup-container__content-wrapper {
      width: 100dvw;
      max-height: 100dvh;
      overflow: auto;
      border-radius: 0;
      box-shadow: none;
    }
  }
}

.frisbuy-popup-container {
  @media screen and (max-width: 1024px) {
    .frisbuy-close-button {
      top: 0;
      right: 0;
      color: #ffffff;
    }
  }
}
</style>

<script setup lang="ts">
import { defineEmits, onBeforeUnmount, onMounted, ref } from "vue";
import { TSwipe } from "../../globals";

const props = withDefaults(
  defineProps<{
    isSwipeEnabled?: boolean;
  }>(),
  {
    isSwipeEnabled: true,
  }
);

const emit = defineEmits<{
  blur: [];
  close: [];
  swipe: [value: TSwipe];
  scroll: [
    {
      top: number;
      bottom: number;
    }
  ];
}>();

onMounted(() => {
  lockWindowScroll();
});

onBeforeUnmount(() => {
  unlockWindowScroll();
});

function onBlurHandler() {
  emit("blur");
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

function onSwipeHandler(direction: TSwipe) {
  if (!props.isSwipeEnabled) {
    return;
  }

  emit("swipe", direction);
}

const contentWrapper = ref<HTMLElement | null>(null);
const contentWrapperSlot = {
  scrollToTop,
};
function scrollToTop() {
  contentWrapper.value?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function scrollHandler(e: Event) {
  const target = e.target as HTMLElement;
  const scrollTop = target.scrollTop;

  // Scroll position event
  const scrollBottom = target.scrollHeight - (target.offsetHeight + scrollTop);
  emit("scroll", {
    top: scrollTop,
    bottom: scrollBottom,
  });
}
</script>
